<template>
	<section>
		<Header></Header>
        <div class="wrap">
    <div class="main">
        <div class="banner">
            <img src="../../../static/images/fwxy-banner.jpg" alt="">
        </div>
        <div class="font-box">
            <h2 class="big-tit">服务协议</h2>

            <p style="color: #333;">2023年12月11日更新</p>
        </div>
        <div class="font-box">
            <p>本协议（以下简称“协议”）内容同时包括<a href="/fwxy" target="_bank">《欧朋隐私政策》</a>,且您（以下简称“用户”）在使用欧朋某一特定服务时，该服务可能会另有单独协议。欧朋相关单独协议一经正式发布，即为本协议不可分割的组成部分。用户使用欧朋服务的行为视为同意被本协议约束。您对前述任何单独协议的接受，即视为您对本协议全部的接受。如果您不接受本协议，您不得使用欧朋的任何服务。
            </p>

            <p style="margin-top: 7px;">如果您未满18周岁，请在法定监护人的陪同下阅读本协议，并特别注意未成年人使用条款。</p>
        </div>
        <div class="font-box">

            <h3>1. 定义 在本协议中以下用语具有如下含义： </h3>

            <p> 1.1 “欧朋”：指欧朋公司及其相关服务可能存在的运营关联单位。 <br>
                1.2 “用户”：指使用欧朋相关服务的法律实体或自然人，在本协议中更多地称为“您”。 <br>
                1.3 “服务”：指欧朋向用户提供的各种服务，包括但不限于欧朋浏览器、欧朋网站。
            </p>
        </div>
        <div class="font-box">
            <p>
                2. 授权 欧朋在此授予用户限制性的、非独家的、不可转让的、不可再授权的仅供用户个人用途（非商业用途）使用欧朋服务的权利。
            </p>
        </div>
        <div class="font-box">

            <h3>3. 服务内容 </h3>

            <p> 3.1 欧朋服务的具体内容由欧朋公司根据实际情况提供。欧朋保留在不发出通知的前提下随时更改、暂停或终止部分或全部服务的权利。用户在此同意欧朋不对任何用户或第三方就欧朋服务的更改、暂停和终止负责。 <br>
                3.2 与相关网络服务有关的设备(如个人电脑、手机、及其他与接入互联网或移动网有关的装置)及所需的费用(如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费)应由用户自行负担。
            </p>
        </div>
        <div class="font-box">

            <h3>4. 用户密码和账户安全 </h3>

            <p> 4.1 您在使用欧朋相关服务时可能需要注册一个账号。用户对其账户和密码承担全部保密责任，且用户对其账户下发生的全部行为负责。 <br>
                4.2 如用户发现帐号遭到未授权的使用或发生其他任何安全问题，应立即修改帐号密码并妥善保管，如有必要，请通知欧朋。 <br>
                4.3 因黑客行为或用户的保管疏忽导致帐号非法使用，欧朋不承担任何责任。
            </p>
        </div>
        <div class="font-box">

            <h3>5. 用户行为 </h3>

            <p> 5.1 作为用户使用欧朋服务的必要条件，用户在此向欧朋承诺不会将欧朋服务用于任何非法或本协议禁止之用途。 <br>
                5.2 用户同意使用欧朋服务仅是用于为个人用途而发送、接收信息。任何未经授权的商业用途都是被禁止的。 <br>
                5.3 欧朋服务的某些功能可能使用户上传的内容（以下简称“用户发出信息”）能够被其他人看到。用户在此同意欧朋不对用户发出信息负责。欧朋亦没有义务审查用户发出信息，但欧朋有修改、删除用户发出信息的权利。<br>
                5.4 您在使用欧朋服务时须遵守法律法规，不得利用欧朋服务从事违法违规行为，包括但不限于： <br>
                （1）发布、传送、传播、储存危害国家安全统一、破坏社会稳定、违反公序良俗、侮辱、诽谤、淫秽、暴力以及任何违反国家法律法规的内容； <br>
                （2）发布、传送、传播、储存侵害他人知识产权、商业秘密等合法权利的内容； <br>
                （3）恶意虚构事实、隐瞒真相以误导、欺骗他人； <br>
                （4）发布、传送、传播广告信息及垃圾信息； <br>
                （5）发布、传送、传播病毒或恶意软件； <br>
                （6）其他法律法规禁止的行为。 <br>
                如果您违反了本条约定，相关国家机关或机构可能会对您提起诉讼、罚款或采取其他制裁措施，并要求欧朋给予协助。造成损害的，您应依法予以赔偿，欧朋不承担任何责任。 <br>
                如果用户之间、用户和欧朋之间发生了关于内容（如用户发出信息）或其他事项（如滥用域名、侵犯版权、商标权等知识产权、诽谤、诈骗、信息滥用、商业交易等）的争议，用户在此同意如果是因用户违反了前述禁止性规定而涉入争议或纠纷的，由用户承担全部责任。<br>
                5.5 欧朋不是用户发出信息的所有者。但一旦用户提交了用户发出信息，用户即授予了欧朋使用、复制、展示、分发和改编用户发出信息的权利，但这种权利仅限于为实现欧朋服务之目的。 <br>
                5.6 用户一旦在欧朋论坛等服务中提交了任何想法、观念、诀窍或技术的，即视为用户同意欧朋对前述想法、观念、诀窍或技术的自由使用。
            </p>
        </div>
        <div class="font-box">
            <h3>6. 第三方网站链接 </h3>

            <p> 6.1
                欧朋服务中包含能连接到第三方网站、文章、照片、文本、图标、图片、设计、音乐、声音、录像、信息、应用、软件和其他来自第三方的内容和项目的链接（以下简称“第三方链接”）。这些第三方链接不经过欧朋的研究、监测和检查，欧朋不对第三方链接内容的准确性、可信赖及其隐私政策负责。<br>
                6.2 如果用户决定访问或使用第三方链接，用户应当自负风险，并应当意识到欧朋的服务条款和隐私政策不能约束第三方链接的内容。用户应当自行查阅第三方链接的使用条款、隐私政策等。
            </p>
        </div>
        <div class="font-box">

            <h3>7. 未成年人使用条款 </h3>

            <p> 7.1 若用户未满18周岁，则为未成年人，应在监护人监护、指导下阅读本协议和使用欧朋服务。 <br>
                7.2 未成年人用户在使用欧朋服务时应注意以下事项，提高安全意识，加强自我保护： <br>
                （1）认清网络世界与现实世界的区别，避免沉迷于网络，影响日常的学习生活； <br>
                （2）填写个人资料时，加强个人保护意识，以免不良分子对个人生活造成骚扰； <br>
                （3）在监护人或老师的指导下，学习正确使用网络； <br>
                （4）避免陌生网友随意会面或参与联谊活动，以免不法分子有机可乘，危及自身安全。 <br>
                7.3 监护人、学校均应对未成年人使用本服务时多做引导。特别是家长应关心子女的成长，注意与子女的沟通，指导子女上网应该注意的安全问题，防患于未然。 <br>
                7.4 欧朋无法禁止未成年人在没有父母同意的情况下进入或使用欧朋相关服务或者留下个人信息，并且，欧朋无法禁止未成年人在欧朋论坛发布个人信息。如果您是未成年人，请遵照7.1条、7.2条、7.3条执行。
            </p>
        </div>
        <div class="font-box">

            <h3>8. 责任限制 </h3>

            <p> 8.1 用户通过欧朋服务取得的信息可能存在不精确之处或印刷错误。因此，欧朋会定期或不定期的修正提供的信息。 <br>
                8.2 欧朋不保证服务是不间断的或没有任何错误的，也不保证这些错误一定被修正，亦不保证欧朋服务及服务器不含病毒或其他有害内容。 <br>
                8.3
                用户在此特别同意欧朋不对非经授权利用欧朋服务获得/修改用户传输数据和信息的行为和结果负责。用户在此特别同意欧朋不对第三方实施的任何威胁、诽谤、淫秽、侵权等违法行为负责。用户在此特别同意欧朋不对欧朋服务中的第三方链接内容负责。
                <br>
                8.4 欧朋保留将本协议项下的权利义务分配给第三方执行的权利。 <br>
                8.5
                欧朋极其供应商不保证欧朋服务在任何情况下的适合性、可靠性、可用性、时效性及准确性。服务以“现状”提供，欧朋及其供应商不对服务的任何权利保证、非侵权、可销售、适合特定目的使用、准确性、完整性、令人满意的质量、良好运行或其他基于法律、法规、运营、交易过程中及商业使用中的状态及陈述做任何明示的、暗示的或强制性的保证，亦不承担任何相关责任。欧朋不保证欧朋服务是不间断、无错误或无病毒的。用户同意本条内容是用户与欧朋协议关系成立的必要条件。若用户不同意本条内容，则用户不得使用欧朋服务。
                <br>
                8.6 虽然本协议不排除亦不限制法定责任，但欧朋不对因合同、侵权或其他任何性质的行为导致的任何预期利润、交易或商誉的损失、任何间接的、偶发的或后续的费用、损害承担责任。
            </p>
        </div>
        <div class="font-box">

            <h3>9. 豁免 </h3>

            <p>因用户使用欧朋服务引发用户被第三方控告时，用户应保证欧朋及其股东、子公司、分支机构、管理人员、雇员免遭任何起诉、请求、损害，并承诺赔偿前述各方因此遭受的损失，该损失数额包括合理的律师费用。
            </p>
        </div>
        <div class="font-box">

            <h3>10. 终止 </h3>

            <p> 10.1如因系统维护或升级的需要而需暂停服务，欧朋将尽可能事先进行通告。 <br>
                10.2如用户违反本协议规定的使用规则的，欧朋有权随时中断或终止向用户提供本协议项下的服务而无需通知用户。 <br>
                10.3除前款所述情形外，欧朋同时保留在不事先通知用户的情况下随时中断或终止部分或全部服务的权利。对于所有服务的中断或终止而造成的任何损失，欧朋无需对用户或任何第三方承担任何责任。
            </p>
        </div>
        <div class="font-box">

            <h3>11. 内容的专有权利 </h3>

            <p>
                用户在此承认欧朋及欧朋供应商或其他内容提供者通过欧朋服务向您呈现的内容，包括但不限于文本、软件、音乐、声音、照片、录像、图标、其他赞助广告或电子推广内容、商业信息，是受版权、商标权、专利和/或其他知识产权法律保护的。用户在此同意不会以任何方式违反法律规定。
            </p>
        </div>
        <div class="font-box">

            <h3>12. 通知 </h3>

            <p>12.1向欧朋发出的通知，应以要求回执的电子邮件的形式向欧朋指定电子邮箱share@oupeng.com发出，该等通知在欧朋收到时生效。 <br>
                12.2向用户发出的通知，应向用户提供的电子邮箱地址或通过欧朋浏览器官方网站或客户端发布，该等通知在通知发出时即生效。
            </p>
        </div>
        <div class="font-box">

            <h3>13. 协议的修改 </h3>

            <p>本协议条款，及《欧朋隐私政策》，可能由欧朋在未来任何时间在不发出通知的情况下修改。修改后的版本会公布在欧朋网站上。用户随时获知更改是用户的义务，且用户是被服务协议及欧朋隐私政策的最新版本约束。
            </p>
        </div>
        <div class="font-box">

            <h3>14. 通则 </h3>

            <p>在不应采用准据法适用其他国家法律的情况下，本协议受中国法律的约束。《联合国国际货物销售合同公约》不适用于本协议。所有本协议的争议应提交中国国际经济贸易仲裁委员会按照该仲裁机构的仲裁规则进行仲裁,
                双方同意该仲裁机构就本协议所有争议事项具有不可撤销的管辖权。仲裁地为中国北京，仲裁语言为中文。若本协议中任何条款被具有司法管辖权的机构认定为无效、违法或不可执行，则其他条款仍继续有效。未经欧朋事先书面授权，用户不得将本协议任何权利义务转让或转移，否则，该等转让、转移无效。
            </p>
        </div>
    </div>
</div>
		<Footer></Footer>
	</section>
</template>

<script>
import Header from '../modules/Header';
import Footer from '../modules/Footer';
export default {
	name: 'Fwxy',
	components: {
		Header,
		Footer
	},
	data() {
		return {
			//
		}
	},
	computed: {}
}
</script>

<style scoped>
.banner {
	width: 100%;
	height: 1.1rem;
    background-size: cover;
}
img {
    width: 100%;
    height: 100%;
}
.big-tit {
	color: #000;
	font-size: 30px;
	line-height: 35px
}

.font-box {
	width: 90%;
	margin: 0 auto;
	padding: 10px 0;
	border-bottom: 1px solid #ddd;
	color: #333;
	font-size: 12px;
	line-height: 18px;
	text-align: justify
}

.font-box a {
	color: #2f82ab;
	text-decoration: underline
}
</style>


// WEBPACK FOOTER //
// src/components/views/Fwxy.vue